var themeContract = {
  argos: {
    linkActive: {
      backgroundColor: 'brand-1-light'
    }
  },
  habitat: {
    linkActive: {
      backgroundColor: 'white'
    }
  },
  tu: {
    linkActive: {
      backgroundColor: 'white'
    }
  },
  nectar: {
    linkActive: {
      backgroundColor: 'white'
    }
  },
  sainsburys: {
    linkActive: {
      backgroundColor: 'white'
    }
  }
};
export { themeContract };